import { useState } from "react";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { DestinationCard } from "../components/DestinationCard";
import { DESTINATIONS } from "../config/site";

const FILTERS = [
  { key: "All", testid: "destination-filter-all" },
  { key: "International", testid: "destination-filter-international" },
  { key: "Domestic", testid: "destination-filter-domestic" },
];

export default function Destinations() {
  const [filter, setFilter] = useState("All");
  const visible = filter === "All" ? DESTINATIONS : DESTINATIONS.filter((d) => d.category === filter);

  return (
    <div className="bg-sandlight pt-[72px]">
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
        <SectionHeading
          eyebrow="Destinations"
          title="Where Will You Go Next?"
          text="Domestic and international destinations our travellers love. Found somewhere you like? Send us an enquiry and we'll explore the options together."
        />

        <div className="mt-8 flex flex-wrap gap-2" role="group" aria-label="Filter destinations">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              type="button"
              data-testid={f.testid}
              onClick={() => setFilter(f.key)}
              className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-all duration-300 ${
                filter === f.key
                  ? "bg-ocean text-white shadow-lg"
                  : "bg-white text-ink/70 ring-1 ring-ocean/10 hover:text-ocean"
              }`}
            >
              {f.key}
            </button>
          ))}
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {visible.map((destination, i) => (
            <Reveal key={destination.name} delay={(i % 3) * 0.08}>
              <DestinationCard destination={destination} />
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-14 rounded-3xl bg-sand p-8 text-center">
          <p className="font-display text-lg font-bold text-ink">
            Don't see your dream destination here?
          </p>
          <p className="mx-auto mt-2 max-w-lg text-sm text-mutedink">
            These are just a starting point. Tell us where you'd like to go —
            across India or anywhere in the world — and we'll discuss the options.
          </p>
          <a
            href="/plan-your-trip"
            data-testid="destinations-custom-enquiry-button"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-turquoise px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-emeraldsea"
          >
            Enquire About Another Destination
          </a>
        </Reveal>
      </section>
    </div>
  );
}
